<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.16 8.43a1 1 0 00-1.16.76v.07a8 8 0 00-16 0v-.07a1 1 0 00-1.95.42l1.85 8.6a1 1 0 001 .79h1.21l-.56 1.68A1 1 0 006.18 22a1.25 1.25 0 00.32 0 1 1 0 001-.68L8.22 19h7.56l.77 2.32a1 1 0 00.95.68 1.25 1.25 0 00.32-.05 1 1 0 00.63-1.27L17.89 19h1.21a1 1 0 001-.79l1.85-8.6a1 1 0 00-.79-1.18zM6 13.72a22.5 22.5 0 016-.72 22.5 22.5 0 016 .72V15H6zM12 4a6 6 0 016 6v1.66a25.61 25.61 0 00-6-.66 25.61 25.61 0 00-6 .66V10a6 6 0 016-6zM6 17v-1h12v1z"/></svg>